import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    loadingImage: css({
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    }),

    loadingImageSkeleton: css({
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
    }),

    loadingImagePlaceholder: css({
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        filter: 'blur(8px)',
        transform: 'scale(1.05)',
    }),

    loadingImageLogo: css({
        position: 'absolute',
        top: '50%',
        left: '50%',
        zIndex: 1,
        width: '72px',
        height: '72px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: 'translate(-50%, -50%)',
        // The HoS logo is black and can't be recoloured, so pair it with a dark spinner and a light glow
        color: isHosTheme ? theme.palette.text.primary : theme.palette.common.white,
        filter: isHosTheme
            ? 'drop-shadow(0 0 6px rgba(255, 255, 255, 0.6))'
            : 'drop-shadow(0 2px 6px rgba(0, 0, 0, 0.4))',
    }),

    loadingImageSpinner: css({
        position: 'absolute',
        inset: 0,
        color: 'inherit',
        '@media (prefers-reduced-motion: reduce)': {
            animationDuration: '4s',
            '& circle': { animation: 'none', strokeDasharray: '80px, 200px' },
        },
    }),

    loadingImageLogoIcon: css({
        width: '36px',
        height: '36px',
    }),

    loadingImageImg: css({
        position: 'relative',
        opacity: 0,
        transition: 'opacity 0.3s ease-in-out',
    }),

    loaded: css({
        opacity: 1,
    }),

    loadingImageError: css({
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.text.disabled,
        background: theme.palette.grey[200],
    }),
};
